import { DOCUMENT } from '@angular/common';
import { EnvironmentProviders, Provider, inject, provideAppInitializer } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';

import { APP_MEDIA_QUERIES } from '../services/viewport.service';
import { PwaInstallService } from './pwa-install.service';
import { PwaUpdateService } from './pwa-update.service';

export const PWA_MANIFEST_HREF = 'manifest.webmanifest';
export const PWA_THEME_COLOR = '#024653';

export function isPwaEnabled(win: Window | undefined = typeof window === 'undefined' ? undefined : window): boolean {
  if (!win || !('serviceWorker' in win.navigator)) return false;
  if (win.location.hostname === 'localhost') return false;
  return APP_MEDIA_QUERIES.some((query) => win.matchMedia(query).matches);
}

export function addPwaHeadTags(document: Document): void {
  if (!document.head.querySelector('link[rel="manifest"]')) {
    const manifest = document.createElement('link');
    manifest.rel = 'manifest';
    manifest.href = PWA_MANIFEST_HREF;
    document.head.appendChild(manifest);
  }

  if (!document.head.querySelector('meta[name="theme-color"]')) {
    const themeColor = document.createElement('meta');
    themeColor.name = 'theme-color';
    themeColor.content = PWA_THEME_COLOR;
    document.head.appendChild(themeColor);
  }
}

export function providePwa(enabled = isPwaEnabled()): (Provider | EnvironmentProviders)[] {
  return [
    provideServiceWorker('ngsw-worker.js', { enabled, registrationStrategy: 'registerWhenStable:30000' }),
    provideAppInitializer(() => {
      inject(PwaInstallService).init();
      if (!enabled) return;
      addPwaHeadTags(inject(DOCUMENT));
      inject(PwaUpdateService).reloadWhenNewVersionIsReady();
    }),
  ];
}
